module.exports = {
  display_guide: [
    {
      title: '',
      shortcuts: [
        { shortcut: 'options', description: 'Open shortcut options modal' },
        { shortcut: 'back_to_article_list', description: 'Go back to article list' }
      ],
      order: 1
    }, {
      title: '',
      shortcuts: [
        { shortcut: 'next_paragraph', description: 'Move selection to next paragraph' },
        { shortcut: 'previous_paragraph', description: 'Move selection to previous paragraph' },
        { shortcut: 'paragraph_reduce_sentence', description: 'Reduce paragraph selection by one sentence' },
        { shortcut: 'paragraph_add_sentence', description: 'Add paragraph selection by one sentence' }
      ],
      order: 2
    }, {
      title: 'Menu Navigation',
      shortcuts: [
        { shortcut: 'editor', description: 'Go to editor' },
        { shortcut: 'top_line', description: 'Go to topline data' },
        { shortcut: 'sources', description: 'Go to sources' },
        { shortcut: 'outlets', description: 'Go to outlets' }
      ],
      order: 3
    }, {
      title: '',
      shortcuts: [
        { shortcut: 'next_organization', description: 'Go to next organization mention' },
        { shortcut: 'undo', description: 'Undo last action (up to 10 actions)' },
        { shortcut: 'reduce_points', description: 'When clicking on sentiment whilst holding this key, sentiment points will reduce' }
      ],
      order: 4
    }, {
      title: 'Tags Menu',
      shortcuts: [
        { shortcut: 'search', description: 'Go to tag menu search' },
        { shortcut: 'organization_tags_menu', description: 'Open / switch menu to organization tags' },
        { shortcut: 'category_tags_menu', description: 'Open / switch menu to category tags' },
        { shortcut: 'back_to_category_tags_menu', description: 'Switch menu to parent category or close menu' }
      ],
      order: 5
    }, {
      title: 'Clipboard Keys',
      shortcuts: [
        { shortcut: 'Number', description: 'Select category to display tags', static: true },
        { shortcut: 'Number.Number', description: 'Select tag to highlight', static: true },
        { shortcut: 'Number.Number > sentiment', description: 'Select tag with sentiment (+ or -)', static: true },
        { shortcut: 'add_tag', description: 'Add highlighted organization / tag to active organizations' },
        { shortcut: 'clear_clipboard', description: 'Clear clipboard' }
      ],
      order: 6
    }, {
      title: '',
      shortcuts: [
        { shortcut: 'publish_clip', description: 'Publish clip' },
        { shortcut: 'next_clip', description: 'Proceed to next clip' },
        { shortcut: 'previous_clip', description: 'Go back to previous clip' }
      ],
      order: 7
    },
  ],
  guide_note: "Please note that '+' refers to 'AND' which indicates that keys must be pressed together and '>' demonstrated the next key to be pressed.",
  shortcuts : {
    next_organization: [
      { key: 'alt', keyCode: 18, order: 1 },
      { 
        key: 'o',
        alternativeKey: 'ø',
        keyCode: 79,
        order: 2,
      }
    ],
    next_paragraph: [
      { key: 'alt', keyCode: 18, order: 1 },
      { key: 'arrowdown', keyCode: 40, order: 2 }
    ],
    previous_paragraph: [
      { key: 'alt', keyCode: 18, order: 1 },
      { key: 'arrowup', keyCode: 38, order: 2 }
    ],
    paragraph_reduce_sentence: [
      { key: 'alt', keyCode: 18, order: 1 },
      { key: 'arrowleft', keyCode: 37, order: 2 }
    ],
    paragraph_add_sentence: [
      { key: 'alt', keyCode: 18, order: 1 },
      { key: 'arrowright', keyCode: 39, order: 2 }
    ],
    top_line: [
      { key: 'shift', keyCode: 16, order: 1 },
      { key: 't', keyCode: 84, order: 2 }
    ],
    sources: [
      { key: 'shift', keyCode: 16, order: 1 },
      { key: 's', keyCode: 83, order: 2 }
    ],
    outlets: [
      { key: 'shift', keyCode: 16, order: 1 },
      { key: 'p', keyCode: 80, order: 2 }
    ],
    editor: [
      { key: 'shift', keyCode: 16, order: 1 },
      { key: 'e', keyCode: 69, order: 2 }
    ],
    category_tags_menu: [{ key: 'c', keyCode: 67, order: 1 }],
    organization_tags_menu: [{ key: 'o', keyCode: 79, order: 2 }],
    search: [
      { key: 'shift', keyCode: 16, order: 1 },
      { key: 'f', keyCode: 70, order: 2 }
    ],
    add_tag:[{ key: 'enter', keyCode: 13, order: 1 }],
    clear_clipboard:[{ key: 'escape', keyCode: 27, order: 2 }],
    options: [
      { key: 'shift', keyCode: 16, order: 1 },
      { key: 'o', keyCode: 79, order: 2 }
    ],
    publish_clip: [
      { key: 'shift', keyCode: 16, order: 1  },
      { key: 'arrowup', keyCode: 38, order: 2 }
    ],
    next_clip: [
      { key: 'shift', keyCode: 16, order: 1 },
      { key: 'arrowright', keyCode: 39, order: 2 }
    ],
    previous_clip: [
      { key: 'shift', keyCode: 16, order: 1 },
      { key: 'arrowleft', keyCode: 37, order: 2 }
    ],
    undo: [
      { key: 'control', keyCode: 17, order: 1 },
      { key: 'z', keyCode: 90, order: 2 }
    ],
    back_to_category_tags_menu: [{ key: 'escape', keyCode: 27, order: 1 }],
    back_to_article_list: [
      { key: 'shift', keyCode: 16, order: 1 },
      { key: 'escape', keyCode: 27, order: 2 }
    ],
    reduce_points: [{ key: 'shift', keyCode: 16, order: 1 }],
    addTag: [
      { key: 'control', keyCode: 17, order: 1}, 
      { key: 'shift', keyCode: 16, order: 2 }, 
      { key: 'a', keyCode: 65, order: 3 }
    ]
  }
};